import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileAvatar } from 'vuetify/lib/components/VList';
import { VListTileTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { class: _vm.$x["address-header-wrapper"] },
        [
          _c("div", { class: _vm.$x["address-header"] }, [
            _c("h1", [
              _c(
                "span",
                { class: _vm.$x["header-icon"] },
                [
                  _c("ns-icon", {
                    class: _vm.$x.flipped,
                    staticStyle: {
                      width: "20px",
                      height: "20px",
                      display: "inline-block",
                      "margin-right": "5px",
                      "vertical-align": "bottom",
                    },
                    attrs: { "icon-name": "icon-truck" },
                  }),
                  _vm._v(" "),
                  _vm.showComplete
                    ? _c("ns-icon", {
                        staticStyle: {
                          width: "12px",
                          height: "12px",
                          position: "relative",
                          left: "-11px",
                          top: "6px",
                        },
                        attrs: { "icon-name": "icon-circle-checkmark-med" },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.checkoutStrings.shippingInformation)),
              ]),
            ]),
            _vm._v(" "),
            _vm.showComplete && !_vm.readonly
              ? _c(
                  "span",
                  {
                    ref: "edit-link",
                    class: _vm.$x["edit-link"],
                    attrs: { "data-testid": "openAddresses" },
                    on: { click: _vm.openAddresses },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.checkoutStrings.editText) +
                        "\n      "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.alerts.length > 0 && _vm.showComplete,
                  expression: "alerts.length > 0 && showComplete",
                },
              ],
            },
            _vm._l(_vm.alerts, function (a) {
              return _c("ns-alert", {
                key: a.id,
                class: _vm.$x["alert-address"],
                attrs: {
                  type: "card",
                  context: a.context,
                  title: a.title,
                  visible: "",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(a.message) },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              })
            }),
            1
          ),
          _vm._v(" "),
          _vm.showComplete
            ? _c("div", { class: _vm.$x["sub-header"] }, [
                _c("div", { class: _vm.$x["summary"] }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.selectedAddressString) +
                      "\n      "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showComplete && _vm.showSignatureRequired
            ? _c(
                VCheckbox,
                {
                  class: _vm.$x["sub-header"],
                  attrs: { color: "#7123D9" },
                  on: { input: _vm.emitSignatureRequired },
                  model: {
                    value: _vm.signatureRequired,
                    callback: function ($$v) {
                      _vm.signatureRequired = $$v
                    },
                    expression: "signatureRequired",
                  },
                },
                [
                  _c("template", { slot: "label" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.t.signatureRequired) +
                        "\n      "
                    ),
                  ]),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.$x["ship-from"] },
            [
              _vm.showComplete && _vm.showShipFrom && _vm.isDistributor
                ? _c(VTextField, {
                    staticClass: "flex-column",
                    attrs: {
                      name: "shipFrom",
                      maxlength: "45",
                      label: _vm.checkoutStrings.shipFromText,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.emitShipFrom()
                      },
                    },
                    model: {
                      value: _vm.distributorName,
                      callback: function ($$v) {
                        _vm.distributorName = $$v
                      },
                      expression: "distributorName",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showSavedAddresses
        ? _c(
            "div",
            { class: _vm.$x["address-wrapper"] },
            [
              _vm._l(_vm.alerts, function (a) {
                return _c("ns-alert", {
                  key: a.id,
                  class: _vm.$x["alert-address"],
                  attrs: {
                    type: "card",
                    context: a.context,
                    title: a.title,
                    visible: "",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "body",
                        fn: function () {
                          return [
                            _c("span", {
                              domProps: { innerHTML: _vm._s(a.message) },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
              _vm._v(" "),
              _c(
                "section",
                [
                  _c("p", { class: _vm.$x["select-address"] }, [
                    _vm._v(_vm._s(_vm.t.chooseAddressMessage)),
                  ]),
                  _vm._v(" "),
                  _c("div", { class: _vm.$x["saved-addresses-header"] }, [
                    _c("h2", { staticClass: "title-small-bold" }, [
                      _c("span", [_vm._v(_vm._s(_vm.t.savedAddresses))]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "h3",
                      {
                        class: _vm.$x["add-address"],
                        attrs: { "data-testid": "openAddressForm" },
                        on: {
                          click: function ($event) {
                            return _vm.openAddressForm(null)
                          },
                        },
                      },
                      [
                        _c("ns-icon", {
                          attrs: { "icon-name": "icon-add", size: "icon-lg" },
                        }),
                        _vm._v(" " + _vm._s(_vm.t.add) + "\n        "),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    VRadioGroup,
                    {
                      model: {
                        value: _vm.selectedAddressId,
                        callback: function ($$v) {
                          _vm.selectedAddressId = $$v
                        },
                        expression: "selectedAddressId",
                      },
                    },
                    _vm._l(_vm.addressList, function (a) {
                      return _c(
                        "div",
                        { key: a.id, class: _vm.$x["address-selector"] },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                VRadio,
                                {
                                  class: _vm.$x["saved-address"],
                                  attrs: { value: a.id },
                                },
                                [
                                  _c("template", { slot: "label" }, [
                                    _c(
                                      "ul",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !_vm.shippingAddressFormat,
                                            expression:
                                              "!shippingAddressFormat",
                                          },
                                        ],
                                      },
                                      [
                                        _c(
                                          "li",
                                          { class: _vm.$x["address-name"] },
                                          [_vm._v(_vm._s(a.addressName))]
                                        ),
                                        _vm._v(" "),
                                        _c("li", [_vm._v(_vm._s(a.address1))]),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: a.address2,
                                                expression: "a.address2",
                                              },
                                            ],
                                          },
                                          [_vm._v(_vm._s(a.address2))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: a.county,
                                                expression: "a.county",
                                              },
                                            ],
                                          },
                                          [_vm._v(_vm._s(a.county))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: a.country === "NZ",
                                                expression: "a.country==='NZ'",
                                              },
                                            ],
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: a.district,
                                                    expression: "a.district",
                                                  },
                                                ],
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(a.district) + ", "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(_vm._s(a.city) + ", "),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      !_vm.hideShippingPostalCode,
                                                    expression:
                                                      "!hideShippingPostalCode",
                                                  },
                                                ],
                                              },
                                              [_vm._v(_vm._s(a.postalCode))]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  a.country !== "NZ" &&
                                                  a.addressType !== "7-11",
                                                expression:
                                                  "a.country!=='NZ' && a.addressType!=='7-11'",
                                              },
                                            ],
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(a.city) +
                                                ",\n                      "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: a.district,
                                                    expression: "a.district",
                                                  },
                                                ],
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(a.district) + ", "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(a.region),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      !_vm.hideShippingPostalCode,
                                                    expression:
                                                      "!hideShippingPostalCode",
                                                  },
                                                ],
                                              },
                                              [_vm._v(_vm._s(a.postalCode))]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: a.country,
                                                expression: "a.country",
                                              },
                                            ],
                                            staticClass: "shippingCountry",
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(a.country) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(a.mobilePhone || a.phone)
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  a.email &&
                                                  _vm.formFields[_vm.country] &&
                                                  _vm.formFields[_vm.country]
                                                    .email &&
                                                  _vm.formFields[_vm.country]
                                                    .email.show,
                                                expression:
                                                  "a.email && formFields[country] && formFields[country].email && formFields[country].email.show",
                                              },
                                            ],
                                          },
                                          [_vm._v(_vm._s(a.email))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  a.instructions &&
                                                  _vm.formFields[_vm.country] &&
                                                  _vm.formFields[_vm.country]
                                                    .instructions &&
                                                  _vm.formFields[_vm.country]
                                                    .instructions.show,
                                                expression:
                                                  "a.instructions && formFields[country] && formFields[country].instructions && formFields[country].instructions.show",
                                              },
                                            ],
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(a.instructions) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        a.defaultShipping
                                          ? _c(
                                              "li",
                                              {
                                                class: _vm.$x["add-default"],
                                                attrs: { name: "defaultAdd" },
                                              },
                                              [
                                                _c("ns-icon", {
                                                  staticStyle: {
                                                    width: "20px",
                                                    height: "20px",
                                                    display: "inline-block",
                                                    "margin-right": "5px",
                                                  },
                                                  attrs: {
                                                    "icon-name":
                                                      "icon-checkmark",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.checkoutStrings
                                                        .defaultAddressText
                                                    )
                                                  ),
                                                ]),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.shippingAddressFormat,
                                            expression: "shippingAddressFormat",
                                          },
                                        ],
                                      },
                                      [
                                        _c(
                                          "li",
                                          { class: _vm.$x["address-name"] },
                                          [_vm._v(_vm._s(a.addressName))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: a.postalCode,
                                                expression: "a.postalCode",
                                              },
                                            ],
                                          },
                                          [
                                            _vm._v(_vm._s(a.postalCode) + " "),
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.getRegionName(a.region)
                                                ),
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: a.city,
                                                expression: "a.city",
                                              },
                                            ],
                                          },
                                          [_vm._v(_vm._s(a.city))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: a.district,
                                                expression: "a.district",
                                              },
                                            ],
                                          },
                                          [_vm._v(_vm._s(a.district))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: a.address1,
                                                expression: "a.address1",
                                              },
                                            ],
                                          },
                                          [_vm._v(_vm._s(a.address1))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: a.address2,
                                                expression: "a.address2",
                                              },
                                            ],
                                          },
                                          [_vm._v(_vm._s(a.address2))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: a.mobilePhone || a.phone,
                                                expression:
                                                  "a.mobilePhone || a.phone",
                                              },
                                            ],
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(a.mobilePhone || a.phone)
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  a.email &&
                                                  _vm.formFields[_vm.country] &&
                                                  _vm.formFields[_vm.country]
                                                    .email &&
                                                  _vm.formFields[_vm.country]
                                                    .email.show,
                                                expression:
                                                  "a.email && formFields[country] && formFields[country].email && formFields[country].email.show",
                                              },
                                            ],
                                            staticClass: "shippingEmail",
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(a.email) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  a.instructions &&
                                                  _vm.formFields[_vm.country] &&
                                                  _vm.formFields[_vm.country]
                                                    .instructions &&
                                                  _vm.formFields[_vm.country]
                                                    .instructions.show,
                                                expression:
                                                  "a.instructions && formFields[country] && formFields[country].instructions && formFields[country].instructions.show",
                                              },
                                            ],
                                            staticClass: "shippingInstructions",
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(a.instructions) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        a.defaultShipping
                                          ? _c(
                                              "li",
                                              {
                                                class: _vm.$x["add-default"],
                                                attrs: { name: "defaultAdd" },
                                              },
                                              [
                                                _c("ns-icon", {
                                                  staticStyle: {
                                                    width: "20px",
                                                    height: "20px",
                                                    display: "inline-block",
                                                    "margin-right": "5px",
                                                  },
                                                  attrs: {
                                                    "icon-name":
                                                      "icon-checkmark",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.checkoutStrings
                                                        .defaultAddressText
                                                    )
                                                  ),
                                                ]),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { class: _vm.$x["address-selector-menu"] },
                            [
                              _c(
                                VMenu,
                                {
                                  attrs: {
                                    attach: "",
                                    left: "",
                                    light: "",
                                    "content-class": "pop-menu",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "button",
                                              _vm._g(
                                                {
                                                  class:
                                                    _vm.$x["action-button"],
                                                  attrs: { name: "editMenu" },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.totalClicks++
                                                    },
                                                  },
                                                },
                                                on
                                              ),
                                              [
                                                _c("ns-icon", {
                                                  attrs: {
                                                    "icon-name":
                                                      "icon-menu-dots",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    VList,
                                    [
                                      _c(
                                        VListTile,
                                        {
                                          attrs: { name: "editPayment" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openAddressForm(a)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            VListTileAvatar,
                                            [
                                              _c("ns-icon", {
                                                attrs: {
                                                  "icon-name": "icon-edit",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(VListTileTitle, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.checkoutStrings.editText
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        VListTile,
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.canDelete,
                                              expression: "canDelete",
                                            },
                                          ],
                                          attrs: { name: "deletePayment" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openDeleteConfirmation(
                                                a.id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            VListTileAvatar,
                                            [
                                              _c("ns-icon", {
                                                attrs: {
                                                  "icon-name": "icon-trashcan",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(VListTileTitle, [
                                            _vm._v(_vm._s(_vm.t.delete)),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        VListTile,
                                        {
                                          attrs: { name: "updateDefault" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.doUpdateDefaultAddress(
                                                a
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            VListTileAvatar,
                                            [
                                              _c("ns-icon", {
                                                attrs: {
                                                  "icon-name": "icon-checkmark",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(VListTileTitle, [
                                            _vm._v(_vm._s(_vm.t.setDefault)),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("div", { class: [_vm.$x["add-address"], _vm.$x.btn] }, [
                    _c(
                      "button",
                      {
                        staticClass: "hit-solid fluid",
                        attrs: {
                          "data-testid": "validateSelectedAddress",
                          disabled: _vm.disableAddressSelectBtn,
                        },
                        on: { click: _vm.validateSelectedAddress },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.checkoutStrings.continueText) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showAddNewAddress
        ? _c(
            "div",
            [
              _vm._l(_vm.alerts, function (a) {
                return _c("ns-alert", {
                  key: a.id,
                  class: _vm.$x["alert-address"],
                  attrs: {
                    type: "card",
                    context: a.context,
                    title: a.title,
                    visible: "",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "body",
                        fn: function () {
                          return [
                            _c("span", {
                              domProps: { innerHTML: _vm._s(a.message) },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
              _vm._v(" "),
              _c("section", { attrs: { id: "addAddressSection" } }, [
                _c("div", { class: _vm.$x.contents }, [
                  _c("div", { class: _vm.$x.left }, [
                    _c("h2", {
                      staticClass: "subtitle-medium-semibold",
                      class: _vm.$x["add-address-title"],
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { class: _vm.$x.right },
                    [
                      _c("ns-shipping-address-form", {
                        ref: "addAddressForm",
                        attrs: {
                          t: _vm.t,
                          "disable-address-name": _vm.disableAddressName,
                          language: _vm.language,
                          country: _vm.formCountry,
                        },
                        model: {
                          value: _vm.formData,
                          callback: function ($$v) {
                            _vm.formData = $$v
                          },
                          expression: "formData",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.isGuest
                    ? _c(
                        "div",
                        { class: [_vm.$x["border-top"]] },
                        [
                          _c(
                            VCheckbox,
                            {
                              attrs: {
                                disabled: _vm.formData.id > 0,
                                color: "#7123D9",
                              },
                              model: {
                                value: _vm.agreeToSave,
                                callback: function ($$v) {
                                  _vm.agreeToSave = $$v
                                },
                                expression: "agreeToSave",
                              },
                            },
                            [
                              _c("template", { slot: "label" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.t.agreeToSaveAddress) +
                                    "\n            "
                                ),
                              ]),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          !_vm.isGuest
                            ? _c(
                                VCheckbox,
                                {
                                  attrs: {
                                    disabled: !_vm.agreeToSave,
                                    color: "#7123D9",
                                  },
                                  model: {
                                    value: _vm.setAsDefault,
                                    callback: function ($$v) {
                                      _vm.setAsDefault = $$v
                                    },
                                    expression: "setAsDefault",
                                  },
                                },
                                [
                                  _c("template", { slot: "label" }, [
                                    _vm._v(_vm._s(_vm.t.setAsDefault)),
                                  ]),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.editingAddress && _vm.canDelete
                            ? _c(
                                "button",
                                {
                                  staticClass: "alert-ghost",
                                  attrs: {
                                    type: "button",
                                    name: "openDeleteConfirmation",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openDeleteConfirmation(
                                        _vm.formData.id
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("ns-icon", {
                                    attrs: { "icon-name": "icon-trashcan" },
                                  }),
                                  _vm._v(
                                    _vm._s(_vm.t.deleteAddress) + "\n          "
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: [
                        _vm.$x.addressButtons,
                        !_vm.isGuest && _vm.$x["border-top"],
                      ],
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "hit-solid fluid form-save",
                          attrs: {
                            name: "saveAddress",
                            "data-testid": "validateAndSave",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.validateAndSave(_vm.formData)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.t.saveAddress) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "hit-outline fluid",
                          attrs: { name: "cancelSaveAddress" },
                          on: {
                            click: function ($event) {
                              return _vm.cleanupAddEditAddress()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.t.cancel) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            VDialog,
            {
              attrs: { "content-class": "delete-confirmation" },
              model: {
                value: _vm.deleteConfirm,
                callback: function ($$v) {
                  _vm.deleteConfirm = $$v
                },
                expression: "deleteConfirm",
              },
            },
            [
              _c(
                VCard,
                [
                  _c(VCardTitle, { staticClass: "title-small-bold" }, [
                    _vm._v(_vm._s(_vm.t.deleteAddress)),
                  ]),
                  _vm._v(" "),
                  _c(VCardActions, [
                    _c(
                      "button",
                      {
                        staticClass: "inverse-solid short",
                        attrs: { name: "cancelDelete" },
                        on: {
                          click: function ($event) {
                            _vm.deleteConfirm = false
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.t.cancel) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "alert-solid short",
                        attrs: { name: "confirmDelete" },
                        on: {
                          click: function ($event) {
                            return _vm.doDeleteAddress()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.t.delete) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        VDialog,
        {
          attrs: { "content-class": "gav-modal", persistent: "" },
          model: {
            value: _vm.showGav,
            callback: function ($$v) {
              _vm.showGav = $$v
            },
            expression: "showGav",
          },
        },
        [
          _c(
            VCard,
            [
              _c("gav", {
                ref: "gav",
                attrs: {
                  "locale-country": _vm.country,
                  "locale-language": _vm.language,
                  "input-address": _vm.inputAddress,
                  callingModule: "defaultCallingModule",
                },
                on: {
                  "confirm-address": _vm.gavConfirmAddress,
                  "toggle-gav": _vm.cancelGavPopup,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }